import { Component, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ERRORS } from './auth.models';
import { Observable } from 'rxjs';
import { LoadLoginContactUsAction, LoadStaticDataAction } from '../../shared/layout/main.actions';
import { selectCountrySelected } from '../../shared/layout/main.selectors';
import { isNullOrUndefined } from 'util';
import { ToastService } from '../../shared/toaster_/toaster_.service';
import { Actions } from 'atlas-cdk';
import { environment } from '../../../environments/environment';
@Component({
  standalone: false,
  selector: 'dsp-auth',
  templateUrl: 'auth.container.html',
  styleUrls: ['auth.container.scss']
})
export class AuthContainerComponent implements OnInit, OnDestroy {
  public page = 'login';

  public loading$: Observable<boolean>;
  private readonly subscription: Subscription = new Subscription();

  public constructor(
    private readonly store: Store<AppState>,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly _toasterService: ToastService
  ) {
    this.loading$ = this.selectLoading();
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.subscribeLoginErrors());
    this.subscription.add(this.subscribeRoute());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      const requestHostname = new URL(environment.API_URL).hostname;
      const currentHostname = window.location.hostname;
      const isMercerDomain = (hostname: string): boolean =>
        hostname.endsWith('.mercer.com');

      const isMarshDomain = (hostname: string): boolean =>
        hostname.endsWith('.marsh.com');

      const validDomainPair =
        (isMercerDomain(currentHostname) && isMercerDomain(requestHostname)) ||
        (isMarshDomain(currentHostname) && isMarshDomain(requestHostname));

      if (!validDomainPair) {
        return;
      }
      if (validDomainPair) {
        if (isNullOrUndefined(country) || country === '') {
          this.store.dispatch(new LoadLoginContactUsAction());
        } else {
          this.store.dispatch(new LoadStaticDataAction(country));
        }
      }
    });
  }

  private subscribeLoginErrors(): Subscription {
    return this.route.queryParams.pipe(
      filter(params => !!params.errorMessage || !!params.reason),
      map(params => (params.errorMessage) ? ERRORS[params.errorMessage] : ERRORS[params.reason])
    ).subscribe(error => {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { errorMessage: null, reason: null },
        queryParamsHandling: 'merge'
      }).then(() => {
        //this.store.dispatch(new AddErrorToastAction(error.message, error.title));
        return this._toasterService.launchAlertError(error.message, Actions.error);
      });
    });
  }

  private subscribeRoute(): Subscription {
    return this.router.events.subscribe(payload => {
      if (payload instanceof NavigationEnd) {
        const url = payload.url.split('/');
        this.page = url[url.length - 1];
      }
    });
  }

  private selectLoading(): Observable<boolean> {
    return this.route.queryParams.pipe(map(params => params.hasOwnProperty('pid')));
  }
}
